import { Close } from '@mui/icons-material';
import { Button, colors, IconButton, Typography } from '@sweep-io/sweep-design';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ReactNode } from 'react';
import { BaseDialog } from '../../common/dialogs/BaseDialog';
import { ActionPaywallSource } from './paywallTypes';
import usePageblockEvents from '../../../hooks/usePageblockEvents';

interface PaywallBlockActionDialogProps {
  title: string;
  infoText: string;
  Image: ReactNode;
  closeDialog: () => void;
  source: ActionPaywallSource;
}

export const PaywallBlockActionDialog = ({
  title,
  infoText,
  Image,
  closeDialog,
  source,
}: PaywallBlockActionDialogProps) => {
  const { bookDemoAndSendEvent } = usePageblockEvents();

  return (
    <BaseDialog
      open={true}
      onClose={closeDialog}
      PaperProps={{
        sx: {
          display: 'flex',
          height: '311px',
          width: '100%',
          maxWidth: '745px',
          overflow: 'hidden',
          borderRadius: '20px',
        },
      }}
    >
      <Box sx={{ position: 'absolute', right: '16px', top: '16px', zIndex: 2 }}>
        <IconButton variant="flat" onClick={closeDialog}>
          <Close />
        </IconButton>
      </Box>
      <Box display="flex" height="100%" flex={1}>
        <Box sx={{ height: '100%', flex: '0 0 300px', overflow: 'hidden' }}>{Image}</Box>
        <Stack flex={2} p={'36px 24px 24px 36px'} height="100%" justifyContent="space-between">
          <Stack gap={1}>
            <Box maxWidth="70%">
              <Typography variant="h1-medium" color={colors.night[900]}>
                {title}
              </Typography>
            </Box>
            <Box maxWidth="85%">
              <Typography variant="body" color={colors.grey[900]}>
                {infoText}
              </Typography>
            </Box>
          </Stack>
          <Box alignSelf="flex-end">
            <Button size="medium" onClick={() => bookDemoAndSendEvent(source)}>
              Talk to us
            </Button>
          </Box>
        </Stack>
      </Box>
    </BaseDialog>
  );
};
